// @vendors
import { useContext, useEffect, useState } from "react"
import { Form, Radio } from 'antd'
import Context from '../../../context/appContext';
import { fieldToClear, getDependencyValue, getKeys, getValueField, setFieldsValue } from '../../../utils/utils';
import moment from 'moment';
// @styles
import './styles.scss';
import CheckboxField from "../checkbox";
import NotifyInfo from "components/notification-info";
export default function RadioCheck({ info, key, form, current }) {
    const [radioInfo, setRadioInfo] = useState({});
    const [isAdult, setIsAdult] = useState(true)
    const validate = info.validate ? info.validate : {};
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm, setChecked, checked, setTypePerson } = useContext(Context);

    useEffect(() => {
        const nfo = current && current.newItems && (current.newItems.find(field => field.key === "tipoDePersonaContratante") || current.newItems.find(field => field.key === "tipoDePersonaAsegurado"));
        const fechaNacimientoTitular = getValueField("fechaNacimiento", formResponses);
        const age = moment().diff(moment(fechaNacimientoTitular, ["DD/MM/YYYY", "YYYY-MM-DD"]), 'years');
        setIsAdult(age >= 18);
        setRadioInfo(nfo);
    }, []);

    useEffect(() => { radioInfo && radioInfo.values && getDefaultValue() }, [radioInfo]);

    useEffect(() => {
        const typePersonInsured = formResponses.find(x => x.key === 'tipoDePersonaAsegurado')?.value;
        const event = { target: { value: typePersonInsured } }
        typePersonInsured && checked && radioInfo && radioInfo.values && onChange(event, true);
        checked && typePersonInsured && form.setFieldsValue({ [radioInfo.key]: typePersonInsured });
        const value = radioInfo.defaultValue;
        !checked && value && form.setFieldsValue({ [radioInfo.key]: value });
        !checked && value && onChange({ target: { value: value } }, true);
        // !checked && radioInfo && radioInfo.values && getDefaultValue();
    }, [checked]);

    useEffect(() => {
        if (radioInfo && radioInfo.key === 'tipoDePersonaContratante' && hiddenFields[radioInfo.key]) {
            radioInfo.value = '';
            const index = formResponses.findIndex(x => x.key === radioInfo.key);
            if (index !== -1 ) {
                formResponses[index].value = '';
            }
        }
        radioInfo && radioInfo.values && getDefaultValue();
    }, [hiddenFields[radioInfo.key]]);

    const resetFields = () => {
        const keys = Object.keys(current);
        let newFormResponses = [...formResponses];
        // setChecked(false);
        const indexCheckData = newFormResponses
            .findIndex((item) => item.key === "datosContratanteIgualAsegurado");
        newFormResponses[indexCheckData].value = false;
        keys && [...keys, 'internalIdentifierContratante'].forEach(keyFe => {
            if (keyFe !== 'tipoDePersonaContratante' && keyFe !== 'datosContratanteIgualAsegurado') {
                disabledFields[keyFe] = false;
                form.resetFields([keyFe]);
                newFormResponses = newFormResponses.filter(value => value.key !== keyFe);
            }
        });

        setDataForm(dataForm => ({
            ...dataForm, formResponses: newFormResponses,
            disabledFields: disabledFields
        }));
    }
    const onChange = (event, defaultV) => {
        // console.log(form && form.getFieldValue());
        // radioInfo && radioInfo.key !== 'tipoDePersonaContratante' && form.resetFields(fieldToClear);        
        const isContratant = radioInfo.key === 'tipoDePersonaContratante';
        // resetFields()  
        setValue(event);
        const dependencyValue = getDependencyValue(current, radioInfo.key, event.target.value, []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                hiddenFields[keyLcl] = item[keyLcl];
                // form.resetFields([keyLcl]);

            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }
        //Limpiar rfc de persona Moral o Fisica para evitar problema de que estaba enviando RFC incorrecto al momento de validar 
        if (isContratant) {
            var newFormResponse = [];
            if (radioInfo.value == "personaMoral") {
                newFormResponse = formResponses.filter(x => x.key != "identificadorPersonaContratante");
                form.resetFields(['sexoContratante'])
            }
            else {
                newFormResponse = formResponses.filter(x => x.key != "identificadorPersonaContratanteMoral");
            }
            setDataForm({ data, formResponses: newFormResponse, hiddenFields: hiddenFields, disabledFields });
        }

        if (radioInfo.key !== 'tipoDePersonaAsegurado') {
            event.target.value === "personaMoral" ? form.resetFields(["fechaNacimientoContratante"]) : form.resetFields(["fechaDeConstitucionContratante"]);
            // !checked && resetFields();
            hiddenFields[radioInfo.key] = false;
            hiddenFields["validarRfcContratante"] = false;
        }

        if (!defaultV) {
            const keys = getKeys(current);
            let newFormResponses = [...formResponses];
            isContratant &&
                keys.push('regimenFiscalContratante', 'cpFacturacion');

            keys && [...keys, 'internalIdentifierContratante'].forEach(keyFe => {
                if (keyFe && keyFe !== 'tipoDePersonaContratante' && keyFe !== 'tipoDePersonaAsegurado' && keyFe !== 'datosContratanteIgualAsegurado' && keyFe !== 'codigoPostalAsegurado' ) {
                    disabledFields[keyFe] = false;
                    form.resetFields([keyFe]);
                    const indexF = formResponses.findIndex(x => x.key === keyFe);
                    if (indexF !== -1) {
                        formResponses[indexF].value = ''
                    }
                    newFormResponses = newFormResponses.filter(value => value.key !== keyFe);
                }
            });
            isContratant && setTypePerson({ tipoDePersonaContratante: event.target.value })
            setDataForm(dataForm => ({
                ...dataForm, formResponses: newFormResponses,
                disabledFields: disabledFields
            }));
        }


    }
    const setValue = (event) => {
        radioInfo.value = event.target.value;
        const index = formResponses.findIndex(x => x.key === radioInfo.key);
        index != -1 ? formResponses[index].value = event.target.value : formResponses.push(radioInfo);
        // console.log();
    }

    const getDefaultValue = () => {
        if (radioInfo && radioInfo.value && radioInfo.value !== null && radioInfo.value !== '') {
            form.setFieldsValue({ [radioInfo.key]: radioInfo.value });
            onChange({ target: { value: radioInfo.value } }, true);
        } else {
            const index = formResponses.findIndex(x => x.key === radioInfo.key);
            let value = index != -1 ? formResponses[index].value : '';
            value = value ? value : radioInfo.defaultValue;
            form.setFieldsValue({ [radioInfo.key]: value });
            onChange({ target: { value: value } }, true);
        }
    }

    return (
        <>
            {checked && radioInfo.key !== 'tipoDePersonaAsegurado' ? '' : <div className="contractor-info">
                <Form.Item
                    className='ant-form-item-normal'
                    label={radioInfo && radioInfo.key !== 'tipoDePersonaAsegurado' && radioInfo.label}
                    name={radioInfo.key}
                    key={key}
                    hidden={hiddenFields[radioInfo.key]}
                    rules={[
                        {
                            required: hiddenFields[radioInfo.key] || disabledFields[radioInfo.key] || radioInfo.disabled ? false : validate.required,
                            message: 'Este campo es requerido'
                        }
                    ]}
                >
                    <Radio.Group
                        className='radiobutton'
                        disabled={false}
                        onChange={onChange}
                    >
                        {radioInfo && radioInfo.values && radioInfo.values.map((item, index) => (
                            <Radio
                                className="radiobutton__item"
                                value={item.value}
                                key={`radio-option-${index}`}
                                data-testid={`radio-option-${index}`}
                            >
                                <em className="fas fa-braille" />
                                <p>{item.label}</p>
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            </div>}
        </>
    )
}